export default __webpack_public_path__ + "static/media/Vrijthof Tiel.7f69f66a.jpg";